<template>
    <div style="width: 100%; display: block">
        <vue-file-agent
            ref="vueFileAgent"
            :theme="'list'"
            :multiple="true"
            :deletable="true"
            :meta="true"
            :accept="'.zip,.pdf,.dwg'"
            :maxSize="'150MB'"
            :maxFiles="50"
            :editable="true"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            @upload="uploaded"
            :helpText="'Selecione um documento'"
            :errorText="{
              type: 'Esse tipo de arquivo não é permitido',
              size: 'Tamanho do arquivo excede os 150MB permitido',
              network: 'Não foi possível fazer o upload do documento',
            }"
            v-model="fileRecords"
        ></vue-file-agent>

        <button v-if="this.uploadHeaders.documentableId" :disabled="loading"
                class="btn btn-upload btn-primary mt-3 mb-2"
                @click="uploadFiles"><span
            class="fa fa-upload"></span> Anexar Documento <span class="loading fa"
                                                         :class="{'fa-sync': loading, 'fa-spin':loading}"></span>
        </button>

    </div>
</template>

<script>

export default {
    name: "MUpload",
    props: {
        setName: {
            type: String,
            default: 'name'
        },
        folder: {
            type: String,
            default: 'documents',
        },
        redirectUrl: {
            type: String,
            default: null,
        },
        documentableName: {
            type: String,
            required: true,
        },
        documentableId: {
            type: String,
            required: true,
        }
    },
    data: function () {
        return {
            fileRecords: [],
            loading: false,
            uploadUrl: '/panel/anexos',
            uploadHeaders: null,
            fileRecordsForUpload: [], // maintain an upload queue
        };
    },
    mounted() {
        let app = this;
        setTimeout(function () {
            app.uploadHeaders = {
                'X-Test-Header': 'vue-file-agent',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'documentableName': app.documentableName,
                'documentableId': app.documentableId,
                'folder': app.folder,
            }
        }, 300)
    },
    methods: {
        uploadFiles: function () {
            this.loading = true;
            this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
            this.fileRecordsForUpload = [];
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.fileRecords.indexOf(fileRecord);
                if (k !== -1) this.fileRecords.splice(k, 1);
            } else {
                if (confirm('Você tem certeza?')) {
                    this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
                }
            }
        },
        fileDeleted: function (fileRecord) {
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                this.fileRecordsForUpload.splice(i, 1);
            } else {
                this.deleteUploadedFile(fileRecord);
            }
        },
        uploaded(response) {
            this.loading = false;
            this.fileRecords = [];
            this.$emit('uploaded')
            if (this.redirectUrl) {
                window.location.href = this.redirectUrl
            } else {
                window.location.reload()
            }
        }
    },
}
</script>

<style scoped>

</style>
